<div class="audio-container">
	<div class="voice-recording-container display">
		<img
			[src]="startRecording"
			alt="Logo"
			(click)="startAudioRecording()"
			*ngIf="!isAudioRecording && !audioBlobUrl"
		/>
		<img
			[src]="pauseRecording"
			alt="Logo"
			*ngIf="isAudioRecording && !audioBlobUrl"
		/>

		<img [src]="stopRecording" alt="Logo" (click)="stopAudioRecording()" />
		<!-- <img [src]="recording" alt="Logo" /> -->

		<!-- <div class="boxContainer">
			<div class="box" [ngClass]="{'animate-box1': isAudioRecording}"></div>
			<div class="box" [ngClass]="{'animate-box2': isAudioRecording}"></div>
			<div class="box" [ngClass]="{'animate-box3': isAudioRecording}"></div>
			<div class="box" [ngClass]="{'animate-box4': isAudioRecording}"></div>
			<div class="box" [ngClass]="{'animate-box5': isAudioRecording}"></div>
			<div class="box" [ngClass]="{'animate-box6': isAudioRecording}"></div>
			<div class="box" [ngClass]="{'animate-box7': isAudioRecording}" ></div>
			<div class="box" [ngClass]="{'animate-box8': isAudioRecording}"></div>
		</div> -->

		<div id="audioTimer">
			<span>{{ audioRecordedTime }} </span>
		</div>
		<audio *ngIf="!isAudioRecording && audioBlobUrl" controls>
			<source [src]="audioBlobUrl" type="audio/mp3" />
		</audio>
	</div>
</div>
